// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (max-width:576px){.modal.payment-modal-wrapper .modal-title{font-family:juana,serif,Georgia,Cambria}.modal.payment-modal-wrapper .close-btn,.modal.payment-modal-wrapper .login-register-heading{display:none}.modal.payment-modal-wrapper .subheading{font-family:juana,serif,Georgia,Cambria;font-size:1.75rem;line-height:2.25rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
